module.exports = __webpack_public_path__ + "static/img/wifi-scan.0c52123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wifi-scan.png
// module id = Ogct
// module chunks = 1